import React, { useEffect, useState } from "react";
import { Box, TextField, Button, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";


export default function FormularioSection({ updateSection, setFormData }) {

  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        const db = getFirestore();
        const docRef = doc(db, "users", user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const profile = docSnap.data();
          setName((profile.firstName ?? '') + ' ' + (profile.lastName ?? ''));
          setEmail(profile.email ?? '');
        }
      }
    });
  }, [])

  // Definición de los hooks para almacenar los valores de los campos
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [street, setStreet] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [colony, setColony] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [addressReference, setAddressReference] = useState("");

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const validateFields = () => {

    if (phone.length < 10) {
      alert("telefono incorrecto");
      return;
    } else if (!name) {
      alert("indica algún nombre");
      return;
    } else if (!street) {
      alert("indica alguna calle");
      return;
    } else if (!postalCode) {
      alert("indica algún código postal");
      return;
    } else if (!colony) {
      alert("indica alguna colonia");
      return;
    } else if (!city) {
      alert("indica alguna ciudad");
      return;
    } else if (!state) {
      alert("indica algún estado");
      return;
    } else if (!country) {
      alert("indica algún país");
      return;
    } else if (!addressReference) {
      alert("indica alguna referencia de domicilio");
      return;
    } else if (!email || !validateEmail(email)) {
      alert("indica un email válido");
      return;
    }
    setFormData({
      name,
      email,
      phone,
      street,
      postalCode,
      colony,
      city,
      state,
      country,
      addressReference
    });
    updateSection('pagoSection');
  };

  const validatePhone = (phone) => {
    if (phone.length > 10) return;
    const validNumber = new RegExp("^[0-9]*$");

    if (validNumber.test(phone)) setPhone(phone);
  };

  const containerStyle = {
    paddingLeft: "10%",
    paddingRight: "10%",
    paddingTop: { xs: "30px", sm: "100px" },
    fontSize: { xs: "22px", sm: "40px" },
    textAlign: "center",
    fontWeight: { xs: "700", sm: "500" },
    fontFamily: "Nunito Sans, sans-serif",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
  };

  const labelStyle = {
    marginBottom: "10px",
    fontSize: "inherit",
    fontFamily: "inherit",
  };

  const fieldStyle = {
    marginBottom: "20px",
  };

  return (
    <Box sx={containerStyle}>
      <Box
        component={ArrowBackIcon}
        sx={{
          fontSize: { xs: "25px", sm: "40px" },
          fontWeight: "900",
          cursor: "pointer",
          position: "absolute",
          left: "10%",
          top: { xs: "32px", sm: "110px" },
        }}
        onClick={() => updateSection('carritoSection')}
      />
      <Box
        sx={{
          textAlign: "center",
          marginBottom: "10px",
          fontFamily: "inherit",
          fontSize: "inherit",
        }}
      >
        Información de envío
      </Box>
      <hr style={{ width: "100%", borderColor: "#ccc" }} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          textAlign: "left",
          width: "100%",
        }}
      >
        <p style={labelStyle}> Nombre </p>
        <TextField
          id="referencia-name"
          placeholder="Nombre de quién recibe el producto"
          variant="filled"
          fullWidth
          style={fieldStyle}
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoComplete="name"
        />

        <p style={labelStyle}> Correo Electrónico </p>
        <TextField
          id="referencia-email"
          placeholder="Email"
          variant="filled"
          fullWidth
          style={fieldStyle}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <p style={labelStyle}> Número de Teléfono</p>
        <TextField
          id="referencia-phone"
          placeholder="Número telefónico"
          variant="filled"
          fullWidth
          style={fieldStyle}
          value={phone}
          onChange={(e) => validatePhone(e.target.value)}
          name="phone"
          autoComplete="tel"
          type="tel"
        />

        <p style={labelStyle}> Calle y número </p>
        <TextField
          id="referencia-street"
          placeholder="EJ: PASEO DE LA REFORMA #163B"
          variant="filled"
          fullWidth
          style={fieldStyle}
          value={street}
          onChange={(e) => setStreet(e.target.value)}
        />

        <p style={labelStyle}> Código postal </p>
        <TextField
          id="referencia-postalCode"
          placeholder="EJ: 066600"
          variant="filled"
          fullWidth
          style={fieldStyle}
          value={postalCode}
          onChange={(e) => setPostalCode(e.target.value)}
        />

        <p style={labelStyle}> Colonia </p>
        <TextField
          id="referencia-colony"
          placeholder="EJ: LINDAVISTA"
          variant="filled"
          fullWidth
          style={fieldStyle}
          value={colony}
          onChange={(e) => setColony(e.target.value)}
          name="address2"
          autoComplete="address-level2"
        />

        <p style={labelStyle}> Ciudad </p>
        <TextField
          id="referencia-city"
          placeholder="EJ: Monterrey"
          variant="filled"
          fullWidth
          style={fieldStyle}
          value={city}
          onChange={(e) => setCity(e.target.value)}
        />

        <p style={labelStyle}> Estado </p>
        <TextField
          id="referencia-state"
          placeholder="EJ: Nuevo León"
          variant="filled"
          fullWidth
          style={fieldStyle}
          value={state}
          onChange={(e) => setState(e.target.value)}
        />

        <p style={labelStyle}> País </p>
        <TextField
          id="country"
          name="country"
          placeholder="EJ: México"
          variant="filled"
          fullWidth
          style={fieldStyle}
          value={country}
          onChange={(e) => setCountry(e.target.value)}
          autoComplete="country"
        />

        <p style={labelStyle}> Referencia de domicilio</p>
        <TextField
          id="referencia-domicilio"
          placeholder="Referencia del domicilio a ingresar"
          multiline
          variant="filled"
          fullWidth
          rows={4}
          onChange={(e) => setAddressReference(e.target.value)}
          style={fieldStyle}
          value={addressReference}
        />

        <Box
          sx={{
            display: "flex",
            justifyContent: { xs: "center", sm: "flex-start" },
          }}
        >
          <Button
            style={{
              width: window.innerWidth < 600 ? "150px" : "300px",
              marginTop: window.innerWidth < 600 ? "20px" : "30px",
              marginBottom: window.innerWidth < 600 ? "20px" : "30px",
              height: window.innerWidth < 600 ? "30px" : "50px",
            }}
            color="primary"
            variant="contained"
            onClick={() => { validateFields(); }}
          >
            <Typography
              sx={{
                fontSize: { xs: "11px", sm: "20px" },
                fontWeight: "900",
                fontFamily: "Nunito Sans, sans-serif",
                textTransform: "none",
              }}
            >
              PROCEDER AL PAGO
            </Typography>
          </Button>
        </Box>
      </div>
    </Box>
  );
}
